import { createSelector, createFeatureSelector } from '@ngrx/store';
import { LayoutState } from './layout.state';

export const layoutSelector = createFeatureSelector<LayoutState>('layout');

export const getShowLeftSidenav = createSelector(layoutSelector, (state: LayoutState) => state.showLeftSidenav);
export const getShowRightSidenav = createSelector(layoutSelector, (state: LayoutState) => state.showRightSidenav);
